export const isGuideBuilderOnboarding = (user, location = {}) => {
  if (user?.details?.type === "onboarding") {
    return true;
  }

  if (
    user?.guide_onboarding &&
    !user.guide_onboarding.completed_at &&
    !user.guide_onboarding.dismissed_at
  ) {
    return true;
  }

  if (location.pathname !== "/guide-designer") {
    return false;
  }

  return new URLSearchParams(location.search || "").has("onboarding");
};
